<template>
  <div>
    <div v-if="isRulesEnabled">
      <!-- Architecture Rules Tab Content -->
      <div v-if="tabType === 'rules'">
        <v-container fluid>
          <v-row>
            <v-col md="6" class="py-0 pr-0">
              <architecture-drivers-ruleset :disabled="false" />
            </v-col>
            <v-col md="6">
              <architecture-drivers-overview :disabled="false" />
            </v-col>
          </v-row>
        </v-container>
      </div>

      <!-- Line Pricing Tab Content -->
      <div v-else-if="tabType === 'pricing'">
        <line-pricing-editor
          ref="linePricingEditorComponent"
          :scenario-key="scenario"
          :architecture-group-id="architectureGroup"
          :editable="canEditRules"
          :disabled="false"
        />
      </div>
    </div>

    <div v-else class="no-filters-message">
      <p>{{ $t(emptyStateTranslationKey) }}</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ArchitectureDriversRuleset from '../components/architecture-drivers-ruleset.vue';
import ArchitectureDriversOverview from '../components/architecture-drivers-overview.vue';
import LinePricingEditor from '../components/line-pricing-editor.vue';

export default {
  name: 'ArchitectureTab',

  components: {
    ArchitectureDriversRuleset,
    ArchitectureDriversOverview,
    LinePricingEditor,
  },

  props: {
    tabType: {
      type: String,
      required: true,
      validator: value => ['rules', 'pricing'].includes(value),
    },
  },

  computed: {
    ...mapState('filters', ['scenario', 'architectureGroup', 'pricingGroup']),
    ...mapGetters('context', ['isPricingSpecialist']),

    isRulesEnabled() {
      return !!this.pricingGroup && !!this.scenario && !!this.architectureGroup;
    },

    canEditRules() {
      return this.isPricingSpecialist;
    },

    emptyStateTranslationKey() {
      return this.tabType === 'rules'
        ? 'dialogs.selectFiltersToViewRules'
        : 'dialogs.selectFiltersToViewLinePricing';
    },
  },
};
</script>

<style scoped>
.no-filters-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
}
</style>
